import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonComponent } from "../button/button.component";

@Component({
  selector: "unsupported-browser-modal",
  templateUrl: "./unsupported-browser-modal.component.html",
  styleUrls: ["./unsupported-browser-modal.component.scss"],
  standalone: true,
  imports: [TranslateModule, CommonModule, ButtonComponent],
})
export class UnsupportedBrowserModalComponent {
  constructor(
    public dialogRef: MatDialogRef<UnsupportedBrowserModalComponent>,
  ) {}
}
